import type { MouseEvent } from "react";

export default function CtaBand() {
  const go = (id: string) => (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <section className="relative bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20warm%20golden%20bokeh%20lights%20softly%20blurred%20over%20a%20dark%20background%2C%20cinematic%20atmosphere%2C%20soft%20film%20grain%2C%20elegant%20background%20texture%2C%20warm%20amber%20and%20deep%20red%20palette%2C%20dreamy%20and%20atmospheric&width=1600&height=700&seq=hap-cta-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-foreground-950/75"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-8 py-16 md:py-24 text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 leading-snug">
          读到这里，再回到剧情看一遍
        </h2>
        <p className="mt-4 text-sm md:text-base text-background-100/85 leading-relaxed max-w-2xl mx-auto">
          影评和观后感，终究只是别人的理解。把基础信息、剧情脉络和自己的感受放在一起，
          你才更容易得出属于自己的结论。
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <a
            href="#overview"
            onClick={go("overview")}
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-accent-500 text-foreground-950 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors hover:bg-accent-400"
          >
            <i className="ri-arrow-up-line"></i>
            回到影片概览
          </a>
          <a
            href="#plot"
            onClick={go("plot")}
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-background-100/40 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors hover:bg-background-50/10"
          >
            <i className="ri-book-open-line"></i>
            重看剧情介绍
          </a>
        </div>
      </div>
    </section>
  );
}